import React, { useState } from "react";

const FeedbackReport = () => {

    return (
        <div>
            <h1 className="title">Feedback Report</h1>
            <hr />
            <div className="page-content-container" id="page-links">
                <p>
                    Click here for the Feedback Report
                </p>
                <a
                    href="https://drive.google.com/file/d/1VJuWHvRLIwIvzjH2oPtVCZvZz0hvf-as/view"
                    download
                >
                    <button>Click here</button>
                </a>
            </div>
        </div>
    );
};

export default FeedbackReport;
